export default __webpack_public_path__ + "static/media/emtcclogo.6ad60ca9.png";